let velocity: any = null;

export const animateElement = (
  elements: any,
  propertyMap: any,
  options?: any,
) => {
  if (window) {
    if (!velocity) {
      return import('velocity-animate').then((module) => {
        velocity = module.default;
        return velocity(elements, propertyMap, options);
      });
    }

    return velocity(elements, propertyMap, options);
  }
  return null;
};
